import { render } from "./GameLoader.vue?vue&type=template&id=837c5e18"
import script from "./GameLoader.vue?vue&type=script&lang=js"
export * from "./GameLoader.vue?vue&type=script&lang=js"

import "./GameLoader.vue?vue&type=style&index=0&id=837c5e18&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__